import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { type IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { EmptySvg } from './NullSvg'

export const NullIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={EmptySvg} {...props} />
}
